export default __webpack_public_path__ + "static/weight-icon-b7df2c70c94f4460e4c6b96334e7c4eb.png";